import { makeStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useSidebarOpenState, SidebarItem } from '@backstage/core-components';
import { SearchModal, SearchModalProvider, useSearchModal } from '@backstage/plugin-search';
import { manewcoTokens } from '@platform/plugin-platform-react';

const useStyles = makeStyles(theme => {
  const MANEWCO = manewcoTokens(theme);
  return {
    box: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      width: 'calc(100% - 32px)',
      margin: '0 16px 6px',
      padding: '10px 14px',
      minHeight: 38,
      border: `1px solid ${MANEWCO.line}`,
      borderRadius: 9,
      backgroundColor: MANEWCO.searchField,
      color: MANEWCO.textSecondary,
      fontFamily: MANEWCO.fontFamily,
      fontSize: 12,
      fontWeight: 600,
      cursor: 'pointer',
      textAlign: 'left',
      '&:hover': { backgroundColor: MANEWCO.hover },
    },
  };
});

const Content = () => {
  const classes = useStyles();
  const { isOpen } = useSidebarOpenState();
  const { state, toggleModal } = useSearchModal();
  return (
    <>
      {isOpen ? (
        <button type="button" className={classes.box} onClick={toggleModal}>
          <SearchIcon fontSize="small" />
          Rechercher
        </button>
      ) : (
        <SidebarItem icon={SearchIcon} text="Rechercher" onClick={toggleModal} />
      )}
      <SearchModal {...state} toggleModal={toggleModal} />
    </>
  );
};

/** Recherche du menu (maquette) : champ encadré « Rechercher » qui ouvre la recherche Backstage. */
export const SidebarSearchBox = () => (
  <SearchModalProvider>
    <Content />
  </SearchModalProvider>
);
